/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaskedInput/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MaskedInput({
  children,
  viewPath = "/DesignSystem/MaskedInput",
  alignSelf = "stretch",
  autoComplete = "on",
  autoFocus,
  className,
  fontSize = 60,
  fontWeight = 300,
  marginTop = 0,
  marginBottom = 0,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  onSubmit,
  paddingBottom = 4,
  paddingRight = 0,
  paddingTop = 4,
  placeholder,
  innerRef,
  textAlign = "center",
  textTransform = "capitalize",
  width = "auto"
  
}) {
  return (<React.Fragment
>
<input
 type="text"
  data-testid="MaskedInput.MaskedInput:1"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 onBlur={onBlur}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 onSubmit={onSubmit}
 placeholder={placeholder}
 ref={innerRef}
 style={{'--as-2-Zo1G5V': alignSelf,'--fs-1-Zo1G5V': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fw-3-Zo1G5V': fontWeight,'--mt-4-Zo1G5V': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-5-Zo1G5V': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pb-6-Zo1G5V': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pr-7-Zo1G5V': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-8-Zo1G5V': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--ta-9-Zo1G5V': textAlign,'--tt-10-Zo1G5V': textTransform,'--w-11-Zo1G5V': typeof width === 'number' ? `${width}px` : width}}
 className={`views-capture ${className} ${styles.MaskedInput1}`}
/>
{children}
</React.Fragment>)
}